// Settings switch in the v10 palette: gold track + thumb when on.
import React from 'react';
import { Switch, type SwitchProps } from 'react-native';
import { useTheme } from '../../v10/theme';

export function ThemedSwitch(props: SwitchProps) {
  const { t, c } = useTheme();
  return (
    <Switch
      trackColor={{ true: c.lime, false: t.lineFaint }}
      thumbColor={props.value ? t.gold : t.ivoryFaint}
      ios_backgroundColor={t.lineFaint}
      {...props}
    />
  );
}
